<template>
  <div class="acomodar">
    <Historial />
  </div>
</template>

<script>
import Historial from '@/components/ModTecnologia/Historial/Historial.vue';
export default {
  name: "HistorialReport",
  components: {
    Historial,
  },
  data() {
    return {};
  },

  mounted() {},

  created() {
    this.cambiarEstadoNavbar()
  },

  methods: {
    cambiarEstadoNavbar() {
    //   // Acción directa para cambiar el estado del navbar a true
     this.$store.dispatch("acciones/CambioNavbar", true);
     },
  },
};
</script>

